module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/philosophy01_sp-713d5265f9e89f0758d27864e14ee3b5.png";